import script from "./TimeIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeIndicator.vue?vue&type=script&setup=true&lang=js"

import "./TimeIndicator.vue?vue&type=style&index=0&id=5f407ef5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f407ef5"]])

export default __exports__